import React from 'react';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { makeMuiStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles(() => ({
  expandMoreIcon: {
    cursor: 'pointer',
    transition: 'transform 0.3s ease',
  },
  expandMoreIconOpen: {
    transform: 'rotate(180deg)',
  },
}));

export interface ExpandMoreButtonProps extends React.ComponentProps<typeof KeyboardArrowDownIcon> {
  icon?: 'KeyboardArrowDown' | 'ArrowDropDown';
  expanded?: boolean;
}

const IconDictionary = {
  KeyboardArrowDown: KeyboardArrowDownIcon,
  ArrowDropDown: ArrowDropDownIcon,
} as const;

export const ExpandMoreButton: React.FC<ExpandMoreButtonProps> = (props) => {
  const { icon = 'KeyboardArrowDown', expanded = false, classes: customClasses, ...rest } = props;

  const classes = useStyles();
  const Component = IconDictionary[icon];

  return (
    <Component
      classes={{
        ...customClasses,
        root: clsx(
          classes.expandMoreIcon,
          customClasses?.root,
          expanded && classes.expandMoreIconOpen,
        ),
      }}
      {...rest}
    />
  );
};
